// src/layouts/MainLayout.js

import React, { memo } from "react";
import SideMenu from "../componentes/SideMenu";
import BottomNav from "../componentes/BottomNav";
import Footer from "../componentes/Footer";
import useRedirecionamentoAoLogin from "../hooks/useRedirecionamentoAoLogin";

const MainLayout = memo(({ children }) => {
    useRedirecionamentoAoLogin();

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200">
            <div className="flex min-h-screen">
                <SideMenu />

                <div className="flex flex-col flex-1 w-full md:ml-20">
                    <main className="flex-1 p-2 sm:p-4 pb-20 md:pb-4">
                        {children}
                    </main>

                    <div className="hidden md:block">
                        <Footer />
                    </div>
                </div>

                <BottomNav />
            </div>
        </div>
    );
});

export default MainLayout;